export default "__VITE_ASSET__503ff2ab__"